import { CHAT_FUNCTIONS } from '../../../config/chatFunctionNames';

/**
 * Check if a message is a booking list response.
 * Detection is purely by function_name — no text pattern matching.
 */
export function isBookingListMessage(message) {
  return message?.function_name === CHAT_FUNCTIONS.VIEW_BOOKINGS;
}

/**
 * Extract booking list data from a message.
 * Returns { bookings, viewHeader, resumePrompt } or null.
 *
 * - viewHeader: Optional header shown above the card grid
 * - resumePrompt: Optional prompt shown below the card grid (e.g. "Continue booking?")
 *
 * @returns {{ bookings: Array, viewHeader: string, resumePrompt: string }|null}
 */
export function getBookingListData(message) {
  if (!isBookingListMessage(message)) return null;

  const bookings = message.raw_output?.bookings;
  if (!Array.isArray(bookings) || bookings.length === 0) return null;

  return {
    bookings,
    viewHeader: message.raw_output?.view_header || '',
    resumePrompt: message.raw_output?.resume_prompt || '',
  };
}

/**
 * Extract header text before the numbered booking list.
 * e.g. "Your Bookings (2 active, 1 cancelled)" from full content.
 * Uses same regex pattern as organization events.
 */
export function getBookingListHeader(content) {
  if (!content) return content;
  const parts = content.split(/\n\n\d+\.\s/);
  return parts[0].trim();
}
